import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Terminal, LogOut } from 'lucide-react';

const Navigation = () => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2 group" data-testid="nav-logo">
            <Terminal className="w-6 h-6 text-emerald-400 group-hover:text-emerald-300 transition-colors" />
            <span className="font-code font-semibold text-lg">WiseCodeDev</span>
          </Link>

          <div className="flex items-center space-x-1 sm:space-x-2">
            <Link to="/" data-testid="nav-home">
              <Button
                variant="ghost"
                className={`${
                  isActive('/') ? 'text-emerald-400' : 'text-zinc-400'
                } hover:text-emerald-400 transition-colors`}
              >
                Home
              </Button>
            </Link>
            <Link to="/about" data-testid="nav-about">
              <Button
                variant="ghost"
                className={`${
                  isActive('/about') ? 'text-emerald-400' : 'text-zinc-400'
                } hover:text-emerald-400 transition-colors`}
              >
                About
              </Button>
            </Link>
            <Link to="/blog" data-testid="nav-blog">
              <Button
                variant="ghost"
                className={`${
                  isActive('/blog') ? 'text-emerald-400' : 'text-zinc-400'
                } hover:text-emerald-400 transition-colors`}
              >
                Blog
              </Button>
            </Link>
            <Link to="/contact" data-testid="nav-contact">
              <Button
                variant="ghost"
                className={`${
                  isActive('/contact') ? 'text-emerald-400' : 'text-zinc-400'
                } hover:text-emerald-400 transition-colors`}
              >
                Contact Me
              </Button>
            </Link>            

            {user ? (
              <>
                <Link to="/admin" data-testid="nav-admin">
                  <Button
                    variant="ghost"
                    className={`${
                      location.pathname.startsWith('/admin') ? 'text-emerald-400' : 'text-zinc-400'
                    } hover:text-emerald-400 transition-colors`}
                  >
                    Admin
                  </Button>
                </Link>
                <Button
                  variant="ghost"
                  onClick={logout}
                  className="text-zinc-400 hover:text-red-400 transition-colors"
                  data-testid="nav-logout"
                >
                  <LogOut className="w-4 h-4" />
                </Button>
              </>
            ) : (
              <Link to="/login" data-testid="nav-login">
                <Button className="bg-emerald-500 hover:bg-emerald-600 text-black font-semibold">
                  Login
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
